module.exports = __webpack_public_path__ + "static/media/refresh-icon.05272d94.svg";